






import { COLOR_PALETTE } from "@/colors";
import { legendTemplate } from "@/utils/chart";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as d3 from "d3";

@Component
export default class DonutChart extends Vue {
  mounted() {
    // $el is from the Vue API.
    // See: https://vuejs.org/v2/api/#el
    this.d3Node = d3.select(this.$el);

    // Initial render
    this.renderChart();
  }

  @Prop({ required: true })
  values!: [{ label: string; value: number | false }];

  // Update chart when values change
  @Watch("values")
  onValuesChange() {
    this.renderChart();
  }

  // `div.chart-donut-container`, set in in mounted lifecycle hook
  d3Node: any;

  get svgContainer() {
    return this.d3Node.select(".chart-donut");
  }

  renderChart() {
    const radius = 1;
    const diameter = radius * 2;

    /**
     * Re-typing as `any` here, because type definitions from `@types/d3` complain
     * when using an allowed data structure
     * https://github.com/d3/d3-shape/blob/v1.3.5/README.md#pie_value
     */
    const values: any = this.values;

    this.d3Node.selectAll("svg").remove();
    this.d3Node.selectAll(".legend").remove();

    const pie = d3
      .pie()
      .sort(null)
      .value((d: any) => {
        return d.value;
      });

    const goldenRatio = 1.618;
    const innerRadius = radius * (1 / goldenRatio);

    const arc = d3
      .arc()
      .outerRadius(radius)
      .innerRadius(innerRadius);

    /**
     * The chart svg has no height or width attributes to allow scaling
     * The `viewbox` attribute sets the svg aspect ratio
     * `'perserveAspectRatio', 'xMinYMin'` scales uniformly
     */
    const svg = this.svgContainer
      .append("svg")
      .attr("viewBox", `0 0 ${diameter} ${diameter}`)
      .attr("perserveAspectRatio", "xMinYMin")
      .append("g")
      .attr("transform", `translate(${radius},${radius})`);

    const g = svg
      .selectAll(".arc")
      .data(pie(values))
      .enter()
      .append("g")
      .attr("class", "arc");

    g.append("path")
      .attr("d", arc)
      .style("fill", (d: any) => {
        return COLOR_PALETTE[d.index];
      });

    // Define div for the legend
    const legend = this.d3Node.append("div").attr("class", "legend");
    const legendList = legend.append("ul").attr("class", "legend-list");

    values.forEach((value: any, idx: number) => {
      legendList.append("li").html(() => {
        return legendTemplate(value.label, idx);
      });
    });
  }
}
